/* @flow */
import React, { Component, PropTypes } from 'react';

import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Glyph from 'components/Glyph.jsx';
import RelationshipActions from 'actions/RelationshipActions';
import MenuItem from 'components/MenuItem.jsx';
import ModalMenuItem from 'components/ModalMenuItem.jsx';

export default class BlockMemberMenuItem extends Component {

  static propTypes = {
    blocked: PropTypes.bool,
    memberId: PropTypes.number.isRequired,
    memberName: PropTypes.string.isRequired,
  };

  blockMember = (): void => {
    const { memberId, memberName } = this.props;
    RelationshipActions.block(memberId, memberName);
  }

  unblockMember = (): void => {
    const { memberId, memberName } = this.props;
    RelationshipActions.unblock(memberId, memberName);
  }

  renderConfirmDialog() {
    const { memberName } = this.props;
    return (
      <ConfirmDialog
        eventScreenName="BlockMemberMenuItem"
        actionButtonText="Block"
        cancelButtonText="Cancel"
        size="xsmall"
        onConfirm={this.blockMember}
        title={`Block ${memberName}?`}
        subtext={'You will no longer be able to direct message or add them to your classes.'}
      />
    );
  }

  render() {
    if (this.props.blocked) {
      return (
        <MenuItem onClick={this.unblockMember}>
          <Glyph name="disabled" />
          <span>
            Unblock user
          </span>
        </MenuItem>
      );
    } else {
      return (
        <ModalMenuItem modal={this.renderConfirmDialog()}>
          <Glyph name="disabled" />
          <span>
            Block user
          </span>
        </ModalMenuItem>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/users/components/BlockMemberMenuItem.jsx